import React, { Component } from 'react';
// import FilterMenu from '@insticator/insticator-ui/dist/material/menu/filtermenu/filtermenu';
import {generateClasses} from '@insticator/insticator-ui/dist/utils/generators'
import DropDownIndicator from '@insticator/insticator-ui/dist/material/dropdowns/dropdownindicator/dropdownindicator'
import FiltersHolder from './filtersholder'
// styles
import injectSheet from 'react-jss';
import styles from './filtermenu_styles';
// definition
import definition from '@insticator/insticator-ui/dist/material/menu/filtermenu/filtermenu_definition.js';
import { defineComponent } from '@insticator/insticator-ui/dist/utils/definecomponent.js';
import {EmojiCategoriesTitles} from "../emojiList";


// class EmojiFilterMenu extends EmojiFilterMenu      // it does not work, WTF !!!

class EmojiFilterMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuOpen: false,
      filters: this.getFiltersState(props.filters)
    };
    this.appliedFilters = JSON.parse(JSON.stringify(this.getFiltersState(props.filters)))
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleOutsideClick, false);
  }

  componentDidUpdate(prevProps) {
    if(Object.keys(this.props.filters).toString() !== Object.keys(prevProps.filters).toString()) {
      this.appliedFilters = JSON.parse(JSON.stringify(this.getFiltersState(this.props.filters, true)));
      this.handleClearFilter();
    }
    this.handleApplyFilter();
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleOutsideClick, false);
  }

  getFiltersState = (filters, clear=false) => {
    const filtersState = {};
    Object.keys(filters).forEach(filter => filtersState[filter] = clear ? [] : filters[filter]['initialState']);
    return filtersState;
  };

  handleOutsideClick = (e) => {
    // ignore clicks on the component itself
    if (this.node.contains(e.target)) { return; }
    if(this.state.menuOpen) this.closeFiltersHolder();
  };

  openClose = () => this.state.menuOpen ? this.closeFiltersHolder() : this.openFiltersHolder();

  openFiltersHolder = () => this.setState({ menuOpen: true });

  closeFiltersHolder = () => this.setState({ menuOpen: false, filters: this.appliedFilters });

  handleSelect = (filterName, filterValue) => {
    const filters = JSON.parse(JSON.stringify(this.state.filters));
    const filterNameIndex = filters[filterName].indexOf(filterValue);
    filterNameIndex < 0 ? filters[filterName].push(filterValue) : filters[filterName].splice(filterNameIndex, 1);
    this.setState({ filters });
  };

  handleClearFilter = () => this.setState({ filters: this.getFiltersState(this.props.filters, true) });

  handleApplyFilter = () => {
    this.appliedFilters = this.state.filters;
    this.props.onApply(this.state.filters);
  };

  renderIndicatorTitle = (activeFilters) => {
    let numOfSelected = 0;
    for(let filt in activeFilters){
      numOfSelected += activeFilters[filt].length;
    }
    return numOfSelected ? `${numOfSelected} Selected` : 'None';
  };

  render() {
    let size;

    switch(true) {
      case this.props?.filters?.categories?.items?.length === this.state?.filters?.categories?.length:
        size = 'All';
        break;
      case this.state?.filters?.categories?.length === 1:
        size = EmojiCategoriesTitles[this.state?.filters?.categories[0]];
        break;
      default:
        size = this.state?.filters?.categories?.length
    }

    return(
      <div className={`menu filtermenu ${generateClasses(this.props)} ${this.props.classes.filtermenu} active-${this.state.menuOpen}`} ref={node => {this.node=node;}}>
        <DropDownIndicator
          active={this.state.menuOpen}
          // title={''}
          name={`Emoji Categories (${size})`}
          // icon={'sliders-h'}
          toggleMenu={this.openClose} />
        <FiltersHolder
          onSelect={this.handleSelect}
          filters={this.props.filters}
          filterState={this.state.filters}
        />
      </div>
    )
  }
}

/* ========== ~~~~~~~~~~ DEFINE COMPONENT ~~~~~~~~~~ ========== */
defineComponent(EmojiFilterMenu, definition, false);



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(EmojiFilterMenu);